import { useSelector } from '@/stores/hooks'
import { getAllLines } from '@/stores/lines'
import { useLoadLines } from '../load/useLoadLines'

export function useDataAllLines({ level = 0 }: { level?: number } = {}) {
	const load = useLoadLines({ level })
	const lines = useSelector(getAllLines)
	return { ...load, lines }
}
